module.exports = __webpack_public_path__ + "img/NITRA.415941b3.jpg";